import type { GetServerSideProps } from 'next';
import feature_new_year from '../../../public/images/feature_new_year_2025.png';
import { createFeatureNamePage } from '../../features/featurePages/featureNameTemplate';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

export const getServerSideProps: GetServerSideProps<CommonFeatureSSRProps> =
  async (ctx) => {
    const { commonFeatureGetServerSideProps } = await import(
      '../../server/features/commonFeatureServerSideProps'
    );
    return commonFeatureGetServerSideProps(ctx);
  };

export default createFeatureNamePage({
  slug: 'new_year',
  featureName: '2025',
  title: '新年の運勢鑑定メニュー一覧',
  description: '恋愛、仕事、金運も　新しい年のあなたを占う2025年運勢占い特集',
  ogImageUrl: 'https://raysee.jp/images/feature_new_year_ogp_2025.png',
  heroImage: feature_new_year,
});
